import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState,useContext,useRef } from "react";
import $ from "jquery";
import "./modalStyle.css";
import { generateRSNADynamicReport, getHTMLTemplate } from "../../../../../service/StudyReportService";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import { circlStyle, covidReportState } from "../../../helper/initialData";
import { UIHelperFactory, applyServerDefaults, onRegenerate, onShowEvent } from "../../../helper/CTBrainUtilities";
import data from '../../../helper/DefaultJson.json';
import { CTBrainTemplate } from "./CTBrainTemplate";
import { CUSTOM_STYLES } from "../../../../../constants/Constants";
import ModalHeader, { iconButtonStyles, iconButtonStylesFunc } from "../../../../../components/Modal/ModalHeader";
import themeContext from "../../../../../context/theme/ThemeContext";

const CTBrainModal = (props) => {
  const containerRef = useRef(null);
  const [htmlContent,setHTMLContent] = useState();
  const [loading,setLoading] = useState(false);
  const {
    generateCTBrainReport,
    alertSuccessModal,setAlertSuccessModal
  } = useContext(studyReportContext);
  const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);


  $(document).ready(function() {
	$('#tabs .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs1 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab1").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs2 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab2").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs3 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab3").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs4 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab4").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs5 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab5").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs6 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab6").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs7 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab7").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});

    $('#tabs8 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab8").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});


    $('#tabs9 .tab-links a').on('click', function(e) {
        console.log("Clicking");
		var currentAttrValue = $(this).attr('href');

		// Show/Hide Tabs
		$(".tab9").hide();   // hiding open tab
     $(currentAttrValue).show(); 
        console.log(currentAttrValue);
		// Change/remove current tab to active
		$(this).parent('li').addClass('active').siblings().removeClass('active');
		e.preventDefault();
	});
});

  const getHTMLTemplateCall = async(id)=>{
    console.log("ID is "+id);
    setLoading(true);
    let res = await getHTMLTemplate(id);
    console.log("Resposne HTML ");
    console.log(res);
    if(res.status == 200){
      if(res.data.result == "SUCCESS"){
        let content = res.data.data.report;
        setHTMLContent(CTBrainTemplate);
        setLoading(false);
      }else{
        setLoading(false);
      }
    }
  }

  useEffect(()=>{
    console.log("IDD "+props.id);
    console.log(props);
      if(props.id != null && props.id != undefined){
          getHTMLTemplateCall(props.id);
          setTimeout(()=>{
            onShowEvent();
          },100);
      }
      return () => {
        clearTimeout();
      };
  },[props.id])



   // const [isModalOpen,setIsModalOpen] = useState(false);

   const dragOptions = {
    moveMenuItemText: "Move",
    closeMenuItemText: "Close",
    menu: ContextualMenu,
    dragHandleSelector: ".ms-Modal-scrollableContent > div:first-child",
  };

    const contentStyles =  mergeStyleSets({
        root:{
            backgroundColor: 'rgba(0, 0, 0, 0.75);',
        },
        container: {
          display: 'flex',
          width:'900px',
          height:'700px',
          overflowY:'hidden',
          overflowX:'hidden',
          borderRadius:'10px',
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: CUSTOM_STYLES.MODAL_BORDER,
          background: getThemeColor("modal-body")
        },
        scrollableContent:{
            overflowY:'hidden'
        },
        header: [
          {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
            background:getThemeColor("modal-header-footer"),
            cursor: "pointer"
          },
        ],
        footer:[
            {
                display: 'flex',
                justifyContent:"space-between",
                background:getThemeColor("modal-header-footer"),
                padding: '10px'
            }
        ],
      });
    
    const cancelIcon = { iconName: 'Cancel' }; 

    const regenerateCTBrainReport = () => {
      let data = onRegenerate();
      if(data.error != null || data.error != undefined){
        console.log(data);
        setAlertSuccessModal(()=>{
          const newItem = {...alertSuccessModal};
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = data.message;
          return newItem;
        });
        return;
      }
      generateCTBrainReport(data,props);   
    }

    
    const regenerateClickedCall = () => {
      
    }
  
    useEffect(() => {
      if (containerRef.current) {
        const elements = containerRef.current.querySelectorAll('.hrct-body select, .hrct-body textarea, .hrct-body input');
        if (elements.length > 0) {
          elements.forEach(element => {
            element.style.backgroundColor = getThemeColor("modal-body");
            element.style.color = getThemeColor("primary-color");
          });
        }
      }
    }, [htmlContent]);

    return (
        <Modal
        isOpen={props.isModalOpen}
        containerClassName={contentStyles.container}
        dragOptions= {{
          moveMenuItemText: "Move",
          closeMenuItemText: "Close",
          menu: ContextualMenu,
          dragHandleSelector: "#header-id",
          keepInBounds: true,
        }}
        styles={contentStyles}
      >
         {loading &&  <Spinner size={SpinnerSize.large} styles={circlStyle}/>}
        {!loading && <>
        <div id="header-id" className={contentStyles.header}>
          <div id="rsna-title" style={{color: getThemeColor("primary-color")}} className="modal-header-heading-updated">
            CT BRAIN
          </div>
          <IconButton
            styles={iconButtonStylesFunc(getThemeColor)}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={props.hideModal}
          />
        </div>
        <div ref={containerRef} 
        style={{color: getThemeColor("primary-color"),accentColor:'rgb(0,117,255)',
          colorScheme:themeName!='light'?'inherit':'none'
        }} id="hrctPopupContext"
        className={`hrct-body ${getScrollBarStyleForTheme(themeName,"modal-scroll-rsna")}`} 
        dangerouslySetInnerHTML={{__html: htmlContent}}
        >
        </div>
        <div className={contentStyles.footer}>
            <div style={{display:'flex'}}>
                <DefaultButton text="Cancel" onClick={props.hideModal} />
                <PrimaryButton style={{marginLeft:'10px'}} text="Reset" onClick={()=>getHTMLTemplateCall(props.id)} />
            </div>
           
            <PrimaryButton text="Regenerate" onClick={()=>{
              console.log("Clicked regenerate");
              regenerateCTBrainReport();
              }} />
        </div></>}
      </Modal>
    )
}

export default CTBrainModal;